import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { getUserAreaDomain } from '@/utils/helpers';
import FileDownload from "js-file-download";
import { useState } from "react";
import { API_URL } from "@/config";
import { PackageDownloadTypes } from "@/types";

const embedPlayerVideoLink = () => `${getUserAreaDomain(window.location.origin)}/embed/player`;

const getQuizScorm = (scormType: PackageDownloadTypes, scormId: number, title: string, institutionId: number) => {
    return axios
        .get(`${API_URL}/api/admin/quiz/${scormType}/${scormId}/scorm?videoLink=${embedPlayerVideoLink()}&institutionId=${institutionId}`,
            { responseType: 'blob' })
        .then((response) => {
            FileDownload(response.data, `${title || scormId}-scorm-export.zip`);
        });
};

/** Quiz V2: GET api/v2/admin/quiz/{quizUuid}/scorm — videoLink + institutionId in query (same pattern as v1 SCORM). */
const getAdminQuizV2Scorm = (quizUuid: string, title: string, institutionId: number) => {
    const params = new URLSearchParams({
        videoLink: embedPlayerVideoLink(),
        institutionId: String(institutionId),
    });
    return axios
        .get(`${API_URL}/api/v2/admin/quiz/${encodeURIComponent(quizUuid)}/scorm?${params.toString()}`, {
            responseType: 'blob',
        })
        .then((response) => {
            FileDownload(response.data, `${title || quizUuid}-scorm-export.zip`);
        });
};

export const usePlaylistScorm = ({
                                     scormType,
                                     scormId,
                                     playlistTitle
                                 }: { scormType: PackageDownloadTypes, scormId: number; playlistTitle: string; }) => {
    const { addNotification } = useNotificationStore();
    const [isLoading, setIsLoading] = useState(false);

    const handleScormDownload = async (institutionId: number) => {
        if (scormId && playlistTitle) {
            try {
                setIsLoading(true);
                await getQuizScorm(scormType, scormId, playlistTitle, institutionId);
                setIsLoading(false);
            } catch (error: any) {
                const responseObj = JSON.parse(await error.response.data.text());
                addNotification({
                    type: 'error',
                    title: responseObj.content.message,
                });
                setIsLoading(false);
            }
        }
    };
    return { isLoading, handleScormDownload }
};

export const useAdminQuizV2Scorm = ({
    quizUuid,
    playlistTitle,
}: {
    quizUuid: string;
    playlistTitle: string;
}) => {
    const { addNotification } = useNotificationStore();
    const [isLoading, setIsLoading] = useState(false);

    const handleScormDownload = async (institutionId: number) => {
        if (quizUuid && playlistTitle) {
            try {
                setIsLoading(true);
                await getAdminQuizV2Scorm(quizUuid, playlistTitle, institutionId);
                setIsLoading(false);
            } catch (error: any) {
                const responseObj = JSON.parse(await error.response.data.text());
                addNotification({
                    type: 'error',
                    title: responseObj.content.message,
                });
                setIsLoading(false);
            }
        }
    };
    return { isLoading, handleScormDownload };
};
